

































import Vue from 'vue'
import { mapState } from 'vuex'
import { Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import FormSwitch from '@/components/FormSwitch.vue'
import { Button } from '@bambora/payment-ui-components'
import { User, Config } from '@/store/context/contextTypes'
import { createDidCodeVerification } from '@/utils/didHelpers'
import { getIdentifyProvider } from '@/utils/helpers'

@Component({
  computed: {
    ...mapState({
      isLoading: (state: any): boolean => state.context.isLoading,
      rememberDevice: (state: any): boolean => state.context.settings.rememberDevice,
      identifyProvider: (state: any): boolean => state.context.config.identifyProvider,
      userDeviceExists: (state: any): boolean => state.context.userDeviceExists,
      user: (state: any): User => state.context.user,
      config: (state: any): User => state.context.config,
      editUser: (state: any): boolean => state.context.config.editUser,
      customShippingAddress: (state: any): User => state.context.customShippingAddress
    })
  },
  components: {
    FormSwitch,
    Button
  }
})

export default class BottomContainer extends Vue {
  user: User
  config: Config
  isLoading: Boolean
  userDeviceExists: Boolean
  editUser: Boolean
  identifyProvider: string
  customShippingAddress: boolean
  @Action('toggleRememberDevice', { namespace: 'context' }) toggleRememberDevice: any
  @Action('setIdentifyWizardStep', { namespace: 'context' }) setIdentifyWizardStep: any
  @Action('validateUser', { namespace: 'context' }) validateUser: any
  @Action('setEditCustomShipping', { namespace: 'context' }) setEditCustomShipping: any
  @Action('setEditUser', { namespace: 'context' }) setEditUser: any
  @Action('setIsLoading', { namespace: 'context' }) setIsLoading: any
  @Getter('identifiedUser', { namespace: 'context' }) identifiedUser: boolean

  get showRememberMeSwitch () {
    // When we don't have a user and we're either in edit mode or the userDevice doesn't exist
    const { userDeviceExists, user, editUser } = this
    return !user && (!userDeviceExists || editUser)
  }

  get showSubmitButton () {
    const { identifyProvider, country } = this.config
    if (identifyProvider && !this.user) {
      const identifyProviderData = getIdentifyProvider(country, identifyProvider)
      if (this.userDeviceExists) {
        return true
      }
      return this.config.identifyProvider && identifyProviderData.showSubmit
    } else {
      return true
    }
  }

  continueHandler () {
    if (!this.isLoading) {
      if (!this.editUser && (this.identifyProvider !== null && this.identifyProvider !== 'manual')) {
        this.providerWizardContinueHandler()
      } else {
        this.fieldWizardContinueHandler()
      }
    }
  }

  // Check DID deviceId + provided value (zip or email for example)
  async providerWizardContinueHandler () {
    this.setIsLoading(true)
    await createDidCodeVerification()
  }

  cancelEdit () {
    this.setEditUser(false)
  }

  fieldWizardContinueHandler () {
    if (!this.editUser) {
      this.setIdentifyWizardStep(undefined)
    } else {
      this.validateUser()
    }
  }
}
